import React from 'react';
import { PropertyListingInterface } from '@templates/property-search-page/interfaces';
import { Box } from '@mui/material';

import { usePropertyHoverUpdaterContext } from '@contexts/PropertyHoverContext';
import { PropertyListCard as FoxtonCard } from '@foxtons/fdl/components/PropertyListCard/index';
import withHydrationOnDemand from 'react-hydration-on-demand';

const PropertyListCard = withHydrationOnDemand({
  on: [['visible', () => ({ rootMargin: '600px 600px 600px 600px' })]]
})(FoxtonCard);

const PropertyListing: React.FC<PropertyListingInterface> = ({
  card,
  basePath,
  favorited,
  saveIconClick,
  handleLoginClickSneakPeek,
  idx,
  selectedPropertyId,
  isRecommendedTag = false,
  pricePeriod
}) => {
  const setHoveredPropertyId = usePropertyHoverUpdaterContext();

  return (
    <Box data-id={card?.propertyId}>
      <PropertyListCard
        selectedPropertyIdCard={card?.propertyId}
        property={card}
        basePath={basePath}
        favorited={favorited}
        heartIconOnClick={(e, isSaved) => saveIconClick(e, card, isSaved)}
        handleLoginClick={(e) => handleLoginClickSneakPeek(e, card)}
        isEagerImg={false}
        isPropertySelected={selectedPropertyId === card?.propertyId}
        isRecommendedProperty={isRecommendedTag}
        pricePeriod={pricePeriod}
        onPropertyCardHover={() => setHoveredPropertyId(card?.propertyId)}
        onPropertyCardLeave={() => setHoveredPropertyId(null)}
        lazilyLoadFirstImage={idx !== 0}
      />
    </Box>
  );
};

export default React.memo(PropertyListing, (prevProps, nextProps) => {
  // re-render if the value of favorited have changed between renders
  // and if the screensize is changed so we resize the card
  return (
    prevProps.favorited === nextProps.favorited &&
    prevProps.viewTypeValue === nextProps.viewTypeValue &&
    prevProps.card?.priceFrom === nextProps.card?.priceFrom &&
    prevProps.pricePeriod === nextProps.pricePeriod
  );
});
